(() => {
  'use strict';
  const init = root => {
    if (!root || root.dataset.txcReady) return;
    root.dataset.txcReady = 'true';
    const panels = [...root.querySelectorAll('[data-txc-panel]')];
    const thumbs = [...root.querySelectorAll('[data-txc-thumb]')];
    const show = index => {
      panels.forEach((panel, i) => { panel.hidden = i !== index; if (panel.hidden) panel.querySelector('video')?.pause(); });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
    };
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
      thumb.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[next].focus(); show(next);
      });
    });
    const form = root.querySelector('[data-txc-form]');
    const mainButton = form?.querySelector('[data-txc-submit]');
    const sticky = root.querySelector('[data-txc-sticky]');
    const stickyButton = root.querySelector('[data-txc-sticky-submit]');
    const variantInput = form?.querySelector('[data-txc-variant]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-txc-product]')?.textContent || '{}').variants || []; } catch { /* Native product form remains available. */ }
    const syncPurchaseLabel = () => {
      const variant = variants.find(v => String(v.id) === variantInput?.value);
      if (!variant) return;
      const count = Math.max(1, parseInt(quantity?.value, 10) || 1);
      const wireless = root.querySelector('[data-power-preview] input:checked')?.value === 'recharge';
      const label = variant.available ? `Add ${count} ${wireless ? 'Wireless ' : ''}${count === 1 ? 'Belt' : 'Belts'}` : 'Sold out';
      root.querySelector('[data-txc-submit-label]').textContent = label;
      root.querySelector('[data-txc-sticky-label]').textContent = label;
    };
    const syncVariant = () => {
      const variant = variants.find(v => String(v.id) === variantInput?.value);
      if (!variant) return;
      root.querySelector('[data-txc-price]').textContent = variant.price;
      root.querySelector('[data-txc-sticky-price]').textContent = variant.price;
      root.querySelectorAll('[data-txc-secondary-price]').forEach(price => { price.textContent = variant.price; });
      const compare = root.querySelector('[data-txc-compare]');
      const saving = root.querySelector('[data-txc-saving]');
      compare.hidden = saving.hidden = !variant.hasCompare;
      compare.textContent = variant.compare;
      const one = root.querySelector('[data-txc-bundle-one]');
      const two = root.querySelector('[data-txc-bundle-two]');
      if (one) one.textContent = variant.bundleOne;
      if (two) two.textContent = variant.bundleTwo;
      const bundleSaving = root.querySelector('[data-txc-bundle-saving]');
      if (bundleSaving) bundleSaving.textContent = 'Save ' + variant.bundleSave + ' when you buy 2';
      const oneCompare = root.querySelector('[data-txc-bundle-one-compare]');
      const twoCompare = root.querySelector('[data-txc-bundle-two-compare]');
      if (oneCompare) { oneCompare.textContent = variant.bundleOneCompare; oneCompare.hidden = !variant.hasCompare; }
      if (twoCompare) { twoCompare.textContent = variant.bundleTwoCompare; twoCompare.hidden = !variant.hasCompare; }
      saving.textContent = 'Save ' + variant.saving;
      [mainButton, stickyButton].filter(Boolean).forEach(button => {
        if (button.hasAttribute('aria-busy')) button.dataset.cartBusyDisabled = String(!variant.available);
        else button.disabled = !variant.available;
      });
      syncPurchaseLabel();
    };
    variantInput?.addEventListener('change', syncVariant);
    const bundle = form?.querySelector('[data-txc-bundle]');
    const quantity = form?.querySelector('[name="quantity"]');
    const syncBundle = () => {
      if (!bundle || !quantity) return;
      bundle.querySelectorAll('input').forEach(radio => {
        radio.checked = radio.value === quantity.value;
        radio.closest('label').classList.toggle('is-active', radio.checked);
      });
    };
    bundle?.addEventListener('change', event => {
      if (event.target.name !== 'tx_bundle') return;
      quantity.value = event.target.value;
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    });
    quantity?.addEventListener('change', () => { syncBundle(); syncPurchaseLabel(); });
    syncBundle();
    syncVariant();
    // Reuse the existing Shopify cart handler; do not create a second add request.
    stickyButton?.addEventListener('click', () => {
      if (!mainButton || mainButton.disabled) return;
      if (!form.reportValidity()) { form.scrollIntoView({block:'center'}); return; }
      form.requestSubmit(mainButton);
    });
    if (sticky && mainButton) {
      const updateSticky = () => {
        const rect = mainButton.getBoundingClientRect();
        sticky.hidden = (rect.top < window.innerHeight && rect.bottom > 0) || window.scrollY < 200 || Boolean(document.querySelector('dialog[open]'));
        root.classList.toggle('txc-preview-active', Boolean(document.getElementById('PBarNextFrame')));
      };
      window.addEventListener('scroll', updateSticky, {passive:true});
      window.addEventListener('resize', updateSticky);
      const observer = new MutationObserver(updateSticky);
      document.querySelectorAll('dialog').forEach(dialog => observer.observe(dialog, {attributes:true, attributeFilter:['open']}));
      updateSticky();
    }
    document.addEventListener('visibilitychange', () => { if (document.hidden) root.querySelectorAll('video').forEach(video => video.pause()); });
  };
  document.querySelectorAll('[data-tx-cro]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-tx-cro]')));
})();
